import { getString } from "../env";

const prefix = "REACT_APP";

const getPrefix = (key: string): string => `${prefix}_${key}`;

const version = getString("VERSION", "0.0.0-development");

const globalConfig = {
	version,
	publicPath: getString(getPrefix("PUBLIC_PATH"), "/"),
	rootUrl: getString(getPrefix("API_ENDPOINT"), "/"),
	googleClientId: getString(getPrefix("GOOGLE_CLIENT_ID"), ""),
	// Cloudflare Turnstile site key for the sign-up challenge. Empty means no script is loaded and no
	// token is sent, which the API reads as "not checked" — so a build without one still registers
	// users rather than refusing every one of them.
	turnstileSiteKey: getString(getPrefix("TURNSTILE_SITE_KEY"), ""),
	// GA4 measurement id ("G-XXXXXXX"). Empty means no script is loaded and nothing is stored —
	// which is the correct state for local development and for any build not given an id.
	ga4MeasurementId: getString(getPrefix("GA4_MEASUREMENT_ID"), ""),
	features: {
		// Public trees render for signed-out visitors: no sign-in wall on the tree, full-view and
		// public-profile pages. Private and draft trees still resolve to an explicit no-access state.
		// Search crawlers are anonymous visitors, so this is also what makes public trees indexable.
		allowAnonymousTreeViewing: true
	},
	i18n: {
		locales: ["en"],
		defaultLocale: "en"
	},
	returnNull: false
};

export default globalConfig;
